import React, { Fragment, useEffect } from 'react';
import { I18nProvider, useLingui } from '@lingui/react';
import { i18n } from '@lingui/core';
import { jsx as _jsx } from "react/jsx-runtime";
export function getI18nInstance() {
  return i18n;
}
export default function TranslationsProvider(_ref) {
  let {
    children,
    locale,
    onActivate = a => {}
  } = _ref;
  useEffect(() => {
    onActivate(locale);
  }, [locale, onActivate]);
  return /*#__PURE__*/_jsx(I18nProvider, {
    i18n: i18n,
    children: /*#__PURE__*/_jsx(I18nWatchLocale, {
      children: children
    })
  });
}
function I18nWatchLocale(_ref2) {
  let {
    children
  } = _ref2;
  const {
    i18n
  } = useLingui();
  // Skip render when locale isn't loaded
  if (!i18n.locale) return null;

  // Force re-render when locale changes. Otherwise string translations (e.g.
  // t`Macro`) won't be updated.
  return /*#__PURE__*/_jsx(Fragment, {
    children: children
  }, i18n.locale);
}